import React from 'react';
import { Link } from 'react-router-dom';

// New, flexible pricing structure
const pricingOptions = [
    { duration: "30 mins", price: "$40" },
    { duration: "45 mins", price: "$50" },
    { duration: "60 mins", price: "$60" },
];

const servicesData = [
    { id: 1, title: "Swedish Massage", desc: "Gentle relaxation massage to improve circulation." },
    { id: 2, title: "Deep Tissue", desc: "Intense pressure to relieve chronic muscle tension." },
    { id: 3, title: "Hot Stone Therapy", desc: "Smooth, heated stones placed on the body to melt away stress." },
    { id: 4, title: "Aromatherapy", desc: "Massage with essential oils to boost mood and health." },
];

function Services() {
    return (
        <div className="container">
            <h1 style={{ textAlign: 'center', color: '#5F7161' }}>Our Services</h1>
            <div className="services-grid">
                {servicesData.map(service => (
                    <div key={service.id} className="service-card">
                        <h3>{service.title}</h3>

                        {/* ITERATE OVER PRICING OPTIONS HERE */}
                        <div className="price-options">
                            {pricingOptions.map((option, index) => (
                                <div key={index} className="price-option-item">
                                    {/* Display duration and price clearly */}
                                    <span className="duration-text">{option.duration}:</span>
                                    <span className="price-text">{option.price}</span>
                                </div>
                            ))}
                        </div>
                        {/* END PRICE OPTIONS */}

                        <p>{service.desc}</p>
                        <Link to="/contact" className="btn">Book Now</Link>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Services;